"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useContext, forwardRef } from "react";
import cx from "classnames";
import Label from "@ingka/label";
import { FormFieldContext } from "@ingka/form-field";
import ValidationBorder from "@ingka/validation-border";
const TextArea = forwardRef(
  (props, ref) => {
    const {
      className,
      onChange,
      prefix = "",
      id,
      describedById,
      label = "Label",
      placeholder,
      disabled = false,
      req = false,
      readOnly = false,
      ...other
    } = props;
    const { shouldValidate, valid, setCharacterCount } = useContext(FormFieldContext);
    const onChangeHandler = (e) => {
      if (setCharacterCount) {
        setCharacterCount(e.target.value.length);
      }
      if (onChange) {
        onChange(e);
      }
    };
    const { value, defaultValue } = other;
    let defaultCharacterCount = 0;
    if (value && value.length) {
      defaultCharacterCount = value.length;
    } else if (defaultValue && defaultValue.length) {
      defaultCharacterCount = defaultValue.length;
    }
    const baseClass = `${prefix}text-area`;
    useEffect(() => {
      if (setCharacterCount) {
        setCharacterCount(defaultCharacterCount);
      }
    }, [defaultCharacterCount]);
    const classes = cx(
      className,
      `${baseClass}`,
      disabled && `${baseClass}--disabled`,
      readOnly && `${baseClass}--read-only`,
      `${prefix}label-wrapper ${prefix}label-wrapper--text-input`
    );
    const ariaInvalid = valid === "error";
    return /* @__PURE__ */ jsxs("div", { className: classes, children: [
      /* @__PURE__ */ jsx(Label, { prefix, htmlFor: id, label }),
      /* @__PURE__ */ jsxs("div", { className: `${baseClass}__wrapper`, children: [
        /* @__PURE__ */ jsx(
          "textarea",
          {
            ref,
            id,
            "aria-describedby": describedById,
            disabled,
            required: req,
            "aria-invalid": shouldValidate ? ariaInvalid : void 0,
            readOnly,
            "aria-required": req,
            onChange: onChangeHandler,
            ...other
          }
        ),
        /* @__PURE__ */ jsx(
          ValidationBorder,
          {
            prefix,
            shouldValidate,
            valid,
            disabled,
            readOnly
          }
        )
      ] })
    ] });
  }
);
TextArea.displayName = "TextArea";
var TextArea_default = TextArea;
export {
  TextArea_default as default
};
